"use client";

import { getSiblingAppUrl } from "@/app/_lib/getSiblingAppUrl";
import { logger } from "@/app/_lib/logger";
import { setNativePreference } from "@medly/auth-config";
import { showLoadingOverlay } from "@medly/auth-config/loading-overlay";
import { isCapacitorNative } from "@medly/auth-config/product-cookie";

export const SwitchPlatformButton = () => {
  return (
    <button
      type="button"
      onClick={async () => {
        showLoadingOverlay();
        const siblingUrl = getSiblingAppUrl();
        localStorage.setItem("selectedPlatform", "exams");
        const native = isCapacitorNative();
        // Navigation must happen regardless of whether the native Preferences
        // plugin resolves — previously an import failure or hang would strand
        // the user behind the loading overlay with no switch.
        const target = native
          ? `${siblingUrl}/picker?product=exams`
          : siblingUrl;
        if (native) {
          try {
            await setNativePreference("selectedPlatform", "exams");
          } catch (err) {
            logger.debug("open.auth.failed_to_persist_capacitor_preference", {
              feature: "auth",
              message: "Failed to persist Capacitor preference",
              error: err,
            });
          }
        }
        window.location.replace(target);
      }}
      className="mx-auto flex items-center gap-2 px-4 py-2 rounded-full bg-[#F2F2F7] text-[13px] font-rounded-bold text-[#1C1C1E] active:scale-[0.97] transition-transform"
    >
      <span>Switch to Medly Exams</span>
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 6L15 12L9 18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};
